import React from "react";
import useTheme from "../../../../common/hooks/useTheme";

/**
 * "Updated" marker for a field carrying an edit that has not been approved yet.
 *
 * Replaces the old `FieldHintMessage` line below the field: per the design it
 * now sits inline, immediately after the field's label, with no icon.
 *
 * Colour is set explicitly rather than inherited because the label turns blue
 * while the field has focus, and this must stay amber.
 */
const UpdatedBadge = () => {
  const theme = useTheme();
  return (
    <span
      style={{
        marginLeft: "6px",
        fontFamily: "var(--font-Medium)",
        fontSize: "10px",
        lineHeight: "16px",
        color: theme.colorTokens.W[70],
      }}
    >
      Updated
    </span>
  );
};

export default UpdatedBadge;
